export const languages = [
  { text: 'English', value: 'en-US' },
  { text: 'Afrikaans (Afrikaans)', value: 'af-ZA' },
  { text: 'Azərbaycan (Azerbaijani)', value: 'az-AZ' },
  { text: 'Bahasa Indonesia (Indonesian)', value: 'id-ID' },
  { text: 'Català (Catalan)', value: 'ca-ES' },
  { text: 'Čeština (Czech)', value: 'cs-CZ' },
  { text: 'Dansk (Danish)', value: 'da-DK' },
  { text: 'Deutsch (German)', value: 'de-DE' },
  { text: 'Español (Spanish)', value: 'es-ES' },
  { text: 'Français (French)', value: 'fr-FR' },
  { text: 'Hrvatski (Croatian)', value: 'hr-HR' },
  { text: 'Íslenska (Icelandic)', value: 'is-IS' },
  { text: 'Italiano (Italian)', value: 'it-IT' },
  { text: 'Latviešu (Latvian)', value: 'lv-LV' },
  { text: 'Lietuvių (Lithuanian)', value: 'lt-LT' },
  { text: 'Magyar (Hungarian)', value: 'hu-HU' },
  { text: 'Nederlands (Dutch)', value: 'nl-NL' },
  { text: 'Norsk bokmål (Norwegian)', value: 'nb-NO' },
  { text: 'Polski (Polish)', value: 'pl-PL' },
  { text: 'Português (Portuguese - Brazil)', value: 'pt-BR' },
  { text: 'Português (Portuguese - Portugal)', value: 'pt-PT' },
  { text: 'Română (Romanian)', value: 'ro-RO' },
  { text: 'Slovenčina (Slovak)', value: 'sk-SK' },
  { text: 'Slovenščina (Slovenian)', value: 'sl-SI' },
  { text: 'Suomi (Finnish)', value: 'fi-FI' },
  { text: 'Svenska (Swedish)', value: 'sv-SE' },
  { text: 'Swahili (Swahili)', value: 'sw-TZ' },
  { text: 'Tiếng Việt (Vietnamese)', value: 'vi-VN' },
  { text: 'Türkçe (Turkish)', value: 'tr-TR' },
  { text: 'Ελληνικά (Greek)', value: 'el-GR' },
  { text: 'Русский (Russian)', value: 'ru-RU' },
  { text: 'Српски (Serbian)', value: 'sr-RS' },
  { text: 'Українська (Ukrainian)', value: 'uk-UA' },
  { text: 'ქართული (Georgian)', value: 'ka-GE' },
  { text: 'Հայ (Armenian)', value: 'hy-AM' },
  { text: 'हिन्दी (Hindi)', value: 'hi-IN' },
  { text: 'বাংলা (Bengali)', value: 'bn-BD' },
  { text: 'ไทย (Thai)', value: 'th-TH' },
  { text: '한국어 (Korean)', value: 'ko-KR' },
  // { text: '廣東話 (Chinese Cantonese, Traditional)', value: 'yue-Hant-HK' },
  { text: '日本語 (Japanese)', value: 'ja-JP' },
  { text: '普通话 (Chinese Mandarin, Simplified)', value: 'cmn' },
  { text: '(Arabic) عربى', value: 'ar-JO' },
  { text: '(Hebrew) ישראל', value: 'he-IL' },
];
